import React from "react";
import { SearchContext } from "./Provider";
var useSearchContext = function() {
    return React.useContext(SearchContext);
};
export { useSearchContext };
